import React, { useState, useRef } from "react";
import { Image, HStack } from "@chakra-ui/react";

const AssessmentAudioManager = ({ onTranscriptComplete, setValue }) => {
  const [isRecording, setIsRecording] = useState(false);
  const recognitionRef = useRef(null);
  const focusedFieldRef = useRef(null);

  const toggleRecording = () => {
    if (isRecording) {
      recognitionRef.current?.stop();
      setIsRecording(false);
    } else {
      const activeElement = document.activeElement;
      focusedFieldRef.current = activeElement?.getAttribute("name");
      startSpeechToText();
    }
  };

  const startSpeechToText = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      alert("Speech recognition is not supported in this browser.");
      return;
    }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    recognition.continuous = true; // ✅ Keeps the mic active

    recognition.onstart = () => {
      setIsRecording(true);
    };

    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript.trim();
      const name = focusedFieldRef.current;

      if (!name) return;

      const match = name.match(/doctorsassessment\[(\d+)\]\.(diagnosis|plan)/);
      if (!match) return;

      const index = parseInt(match[1], 10);
      const field = match[2];

      // ✅ Update both UI and react-hook-form state
      onTranscriptComplete(index, field, transcript);
      if (setValue) {
        setValue(`doctorsassessment[${index}].${field}`, transcript);
      }
    };

    recognition.onerror = (event) => {
      console.error("Speech recognition error:", event.error);
      setIsRecording(false);
    };

    recognition.onend = () => {
      // Keeps mic active until manually toggled
      if (isRecording) {
        recognition.start();
      } else {
        setIsRecording(false);
      }
    };

    recognitionRef.current = recognition;
    recognition.start();
  };

  return (
    <HStack spacing={2} py={2} px={2}>
      <Image
        onMouseDown={(e) => {
          e.preventDefault(); // Prevents blur
          const active = document.activeElement;
          focusedFieldRef.current = active?.getAttribute("name");
        }}
        onClick={toggleRecording}
        boxSize="36px"
        opacity="0.7"
        cursor="pointer"
        src={isRecording ? "/assets/svgs/un-mute.svg" : "/assets/svgs/mute.svg"}
        alt="mic-toggle"
      />
    </HStack>
  );
};

export default AssessmentAudioManager;
